import { connect } from 'react-redux';
import _pick from 'lodash/pick';

import {
  getPagesById,
  getPagesTypeToId,
  getPagesByOrderedId,
} from 'selectors/website/pageSelectors';

import WebsitePreview from 'components/manage/website/WebsitePreview/WebsitePreview';
import './WebsitePreviewContainer.less';

const mapStateToProps = state => {
  const pageType = 'EVENT';
  const eventPageId = getPagesTypeToId(state)[pageType];
  const eventPage = getPagesById(state)[eventPageId];
  const values = _pick(eventPage, ['title', 'description', 'hidden', 'header_image_url']);

  return {
    isHome: false,
    values,
    activePage: eventPage,
    pages: getPagesByOrderedId(state),
    wedding: state.wedding.wedding,
    weddingValues: null,
    account: state.wedding.account,
  };
};

export default connect(mapStateToProps)(WebsitePreview);



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomEdit/components/WebsitePreviewContainer/index.js